import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../services/api.service";
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { goToLoginIfNotLoggedIn } from 'src/services/ObservableExtension';
import * as moment from 'moment';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  destroy$ = new Subject<any>();
  sensors: any = [];
  isLoading = true;

  range = 'year';
  labelX = "Monat";
  actualTimeSpan = 4;
  primaryChartColor = '#00b1e8';
  secondaryChartColor = '#f37021';
  currentMonth: any;
  currentYear: any;
  currentDay: any;
  isValveOpen: boolean = true;
  maxDays: any;
  ranges: {};
  options: {};
  selected: { startDate: moment, endDate: moment };
  fromDate: any;
  toDate: any;
  opens: string;
  locale: {};
  alwaysShowCalendars: boolean = true;
  keepCalendarOpeningWithRange: boolean = true;
  diff_of_days: any;
  range_selected: any;
  filter: string = "hour";
  maxDateSelection: moment = moment();
  diff_of_months: number;

  waterConsuptionAggregation: any;
  waterPressureAggregation: any = [];
  totalEuroAmount: number = 0;

  constructor(
    public api: ApiService,
    private router: Router,
    private helperService: HelperService) {
    api.pageTitle = 'Cockpit';
  }

  ngOnInit() {
    this.initialiseDateRange();
    this.datesUpdated(this.selected);

    //var today = new Date();
    //this.currentDay = today.getDate();
    //this.currentMonth = today.getMonth() + 1; //January is 0!
    //this.currentYear = today.getFullYear();

    //this.loadWaterDistribution("hour");
    //this.loadpressureDistribution("year");
    //this.checkValveStatus();
    //this.daysInMonth(this.currentMonth, this.currentYear);
  }

  checkValveStatus() {
    this.api.get("customer/valveStatus").subscribe((status: any) => {
      this.isValveOpen = status;
    });
  }

  loadWaterDistribution(range: string) {

    this.api.get("measurementAggregations/aggregatedWaterConsuption?range=" + range + '&day=' + this.currentDay + '&month=' + this.currentMonth + '&year=' + this.currentYear).subscribe((consuptionData: any) => {

      var dataset = {
        label: "",
        data: [],
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1
      }
      var datasets = [dataset];

      var waterConsuptionAggregation = {
        labels: [],
        datasets
      }

      var numberOfBars;
      if (consuptionData != null) {
        if (range == "year") { numberOfBars = 12; this.labelX = "Monat" };
        if (range == "month") { numberOfBars = 31; this.labelX = "Tag" };
        if (range == "day") { numberOfBars = 24; this.labelX = "Stunde" };
        if (range == "hour") { numberOfBars = 24; this.labelX = "Stunde" };

        this.renderBarChart(waterConsuptionAggregation, consuptionData);
        this.waterConsuptionAggregation = waterConsuptionAggregation;
      }
    });
  }

  renderBarChart(waterConsuptionAggregation, consuptionData) {
    waterConsuptionAggregation.datasets[0].label = "aggregierter Wasserverbrauch [L]";

    for (var j = 0; j < consuptionData.length; j++) {
      var consuption = consuptionData[j];

      waterConsuptionAggregation.labels.splice(waterConsuptionAggregation.labels.length, 0, consuption.Intervall);
      waterConsuptionAggregation.datasets[0].data.splice(waterConsuptionAggregation.labels.length, 0, consuption.ValueAggregation);
    }

    //Old code
    //for (var i = 1; i <= numberOfBars; i++) {
    //  var flag = false;
    //  for (var j = 0; j < consuptionData.length; j++) {

    //    if (consuptionData[j].Intervall == i) {
    //      var consuption = consuptionData[j];

    //      waterConsuptionAggregation.labels.splice(waterConsuptionAggregation.labels.length, 0, consuption.Intervall);
    //      waterConsuptionAggregation.datasets[0].data.splice(waterConsuptionAggregation.labels.length, 0, consuption.ValueAggregation);
    //      flag = true;
    //    }
    //  }
    //  if (flag == false) {
    //    waterConsuptionAggregation.labels.splice(waterConsuptionAggregation.labels.length, 0, i);
    //    waterConsuptionAggregation.datasets[0].data.splice(waterConsuptionAggregation.labels.length, 0, 0);
    //  }
    //}
    this.waterConsuptionAggregation = waterConsuptionAggregation;
  }

  loadpressureDistribution(range: string) {

    this.api.get("measurementAggregation/waterPressure?range=" + range).subscribe((pressureDistribution: any) => {
      this.waterPressureAggregation = pressureDistribution;

      var statisticalData = [{
        label: "Max",
        lineTension: 0,
        data: [],
        borderColor: this.primaryChartColor
      },
      {
        label: "Mean",
        lineTension: 0,
        data: [],
        borderColor: this.secondaryChartColor
      }, {
        label: "Min",
        lineTension: 0,
        data: [],
        borderColor: this.primaryChartColor
      }];

      var numberOfBars;

      if (range == "year") { numberOfBars = 12; this.labelX = "Monat" };
      if (range == "month") { numberOfBars = 31; this.labelX = "Tag" };
      if (range == "day") { numberOfBars = 24; this.labelX = "Stunde" };

      this.renderLineChart(statisticalData, pressureDistribution, numberOfBars);
      //this.waterPressureAggregation = statisticalData;

    });

  }

  renderLineChart(statisticalData: any, pressureDistribution: any, numberOfBars: number) {

    for (var i = 1; i <= numberOfBars; i++) {
      for (var j = 0; j < pressureDistribution.length; j++) {

        if (pressureDistribution[j].Interval == i) {
          statisticalData[0].data.splice(0, 0, { x: pressureDistribution[j].Interval, y: pressureDistribution[j].Max })
          statisticalData[1].data.splice(0, 0, { x: pressureDistribution[j].Interval, y: pressureDistribution[j].Average })
          statisticalData[2].data.splice(0, 0, { x: pressureDistribution[j].Interval, y: pressureDistribution[j].Min })
        }

      }
    }

    this.waterPressureAggregation = statisticalData;

  }

  GetAggregatedData(range: string) {
    this.api.get("measurementAggregations/aggregatedWaterConsuption?range=" + range + '&day=' + this.currentDay + '&month=' + this.currentMonth + '&year=' + this.currentYear).subscribe((consuptionData: any) => {
      var dataset = {
        label: "",
        data: [],
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1
      }
      var datasets = [dataset];

      var waterConsuptionAggregation = {
        labels: [],
        datasets
      }
      var numberOfBars;
      if (range == "year") { numberOfBars = 12; this.range = "year"; this.labelX = "Monat" }
      if (range == "month") { numberOfBars = 31; this.range = "month"; this.labelX = "Tag" }
      if (range == "hour") { numberOfBars = 24; this.range = "hour"; this.labelX = "Stunde" }

      this.renderBarChart(waterConsuptionAggregation, consuptionData);

    });

    this.loadpressureDistribution(range);
  }

  increment(range) {
    if (range == 'hour') {
      var daycount = this.currentDay;
      if (++daycount < this.maxDays) {
        this.currentDay++;
      } else {
        this.currentDay = 1;
      }
    };
    if (range == 'month') {
      var monthcount = this.currentMonth;
      if (++monthcount < 13) {
        this.currentMonth++;
      } else {
        this.currentMonth = 1;
      }
    };
    if (range == 'year') { this.currentYear++ };

    this.GetAggregatedData(range);
  }

  decrement(range) {
    if (range == 'hour') {
      var result = this.currentDay;
      if (--result > 1) {
        this.currentDay--;
      } else {
        this.currentDay = this.maxDays;
      }
    };
    if (range == 'month') {
      var monthcount1 = this.currentMonth;
      if (--monthcount1 < 1) {
        this.currentMonth = 12;
      } else {
        this.currentMonth--;
      }
    };
    if (range == 'year') { this.currentYear-- };

    this.GetAggregatedData(range);
  }

  daysInMonth(month: number, year: number) {
    this.maxDays = new Date(year, month, 0).getDate();
  }

  initialiseDateRange() {
    //these function will set short names abbrevation for weekdays in german language
    var localeData = moment.updateLocale('de', {
      weekdaysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
    });

    this.selected = { startDate: moment(), endDate: moment() };
    this.opens = "left";
    this.locale = {
      applyLabel: 'Anwenden',//Apply
      format: 'MM-DD-YYYY',
      displayFormat: 'MM/DD/YYYY',
      separator: ' To ',
      customRangeLabel: 'Benutzerdefiniert',//Custom
      monthNames: moment.localeData('de').monthsShort(),//Set month names in german
      daysOfWeek: localeData.weekdaysShort()//Set weekday names in german
    };
    this.options = {
      year: 'numeric', month: '2-digit', day: '2-digit'
    };
    this.ranges = {
      'Heute': [moment(), moment()],//Today
      'Gestern': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],//Yesterday
      'Letzten 7 Tage': [moment().subtract(6, 'days'), moment()],//Last 7 Days
      'Letzte 30 Tage': [moment().subtract(29, 'days'), moment()],//Last 30 Days
      'Diesen Monat': [moment().startOf('month'), moment().endOf('month')],//This Month
      'Dieses Jahr': [moment().startOf('year'), moment().endOf('year')],
      'Letzte 3 Jahre': [moment().subtract(3, 'years'), moment()],
      'Im vergangenen Monat': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]//Last Month
    }
  }

  rangeClicked(range): void {
    if (range) {
      this.range_selected = range.label;
      if (this.range_selected == "Heute" || this.range_selected == "Gestern") {
        this.filter = "hour";
      }
      else if (this.range_selected == "Letzten 7 Tage" || this.range_selected == "Letzte 30 Tage" || this.range_selected == "Diesen Monat" || this.range_selected == "Im vergangenen Monat") {
        this.filter = "month";
      }
      else {
        this.filter = "month";
      }
    }
  }

  datesUpdated(range): void {
    if (range && (range.startDate && range.endDate)) {
      this.fromDate = range.startDate._d.toLocaleDateString("en-US", this.options);
      this.toDate = range.endDate._d.toLocaleDateString("en-US", this.options);
      this.diff_of_days = moment(this.toDate).endOf('day').diff(moment(this.fromDate).startOf('day'), 'days') + 1;
      this.diff_of_months = moment(this.toDate).diff(moment(this.fromDate), 'months');
      this.filter = this.helperService.getFilterRangeBetweenDates(this.diff_of_days, this.diff_of_months);

      //To include the end date we have to increase it by day 1 so, in backend enddate came into consideration
      var currentDate = moment(this.fromDate);
      var is_same_date = currentDate.isSame(this.toDate);
      if (is_same_date) {
        this.toDate = currentDate.add(1, 'day')._d.toLocaleDateString("en-US", this.options);
      } else {
        var currentEndDate = moment(this.toDate);
        this.toDate = currentEndDate.add(1, 'day')._d.toLocaleDateString("en-US", this.options);
      }

      this.fetchGraphData(this.fromDate, this.toDate);
    }
  }

  defineRange(number_of_days) {
    if (number_of_days == 1) {
      this.filter = "hour";
    }
    else if (number_of_days > 1) {
      this.filter = "month";
    }
  }

  fetchGraphData(startDate, endDate) {
    if (startDate && endDate) {
      this.api.get("measurementAggregations/aggregatedWaterConsumptionRange?fromDate=" + startDate + '&toDate=' + endDate + '&range=' + this.filter).subscribe((consuptionData: any) => {
        this.totalEuroAmount = consuptionData.euroAmount || 0;
        var dataset = {
          label: "",
          data: [],
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1
        }
        var datasets = [dataset];

        var waterConsuptionAggregation = {
          labels: [],
          datasets
        }

        this.labelX = this.helperService.getAxesLabelForRange(this.diff_of_days, this.diff_of_months);

        //var numberOfBars;
        //if (this.range_selected == "Letzten 7 Tage" || this.range_selected == "Letzte 30 Tage" || this.range_selected == "Diesen Monat" || this.range_selected == "Im vergangenen Monat") {
        //  numberOfBars = 31; this.labelX = "Tag";
        //} else {
        //  if (this.diff_of_days == 1) {
        //    numberOfBars = 24; this.labelX = "Stunde";
        //  }
        //  else if (this.diff_of_days > 1 && this.diff_of_days <= 7) {
        //    numberOfBars = 31; this.labelX = "Tag";
        //  }
        //  else {
        //    numberOfBars = 31; this.labelX = "Tag";
        //  }
        //}

        this.renderBarChart(waterConsuptionAggregation, consuptionData.data);
        this.clearFilters();
      });
    }
  }

  clearFilters() {
    this.range_selected = "";
    this.filter = "";
  }
}
